<div #refNavBar class=" navbar-sm  " style="padding: .375rem 0">
  <div class="container-fluid">
    <div class="flex-fill overflow-auto overflow-lg-visible scrollbar-hidden">
      <ul class="nav gap-1 flex-nowrap flex-lg-wrap fw-semibold" id="navbar-horizontal">

        @for (navRoot of navItems; track navRoot; let idxRoot = $index) {
          <li class="nav-item me-2 {{(navRoot.children && navRoot.children.length && navRoot.path !== 'setting')?'dropdown':''}}"
            [class.show]="menuParentState == 'root_' + idxRoot"
            (click)="navRoot.path !== 'setting' && toggleParentMenu(idxRoot, $event)">
            @if ((navRoot.children && navRoot.children.length && navRoot.path !== 'setting')) {
              <a
                [class.active]="navRoot.active"
                class="navbar-nav-link dropdown-toggle rounded align-items-baseline text-white cursor-pointer">
                {{ navRoot.originTitle ? navRoot.originTitle : navRoot.title | transloco }}
              </a>
            } @else {
              <a [class.active]="navRoot.active"
                 [routerLink]="navRoot.url"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: false }"
                 class="navbar-nav-link rounded align-items-baseline text-white cursor-pointer">
                {{ navRoot.originTitle ? navRoot.originTitle : navRoot.title | transloco }}
              </a>
            }
            @if (navRoot.children && navRoot.children.length) {
              <div class="dropdown-menu mt-1_5" data-bs-popper="static"
                [class.dropdown-menu-end]="idxRoot >= navItems.length - 3"
                [class.show]="menuParentState == 'root_' + idxRoot">
                @for (navTwo of navRoot.children; track navTwo; let idxTwo = $index) {
                  @if (navTwo.children && navTwo.children.length) {
                    <div class="dropdown-submenu"
                      [class.dropdown-submenu-start]="idxRoot >= navItems.length - 1"
                      [class.show]="menuSubStates == 'sub_' + idxTwo"
                         (mouseenter)="openSubMenu(idxTwo)"
                         (mouseleave)="closeSubMenu(idxTwo)"
                      (click)="toggleSubMenu(idxTwo, $event)">
                      <a
                        [class.active]="navTwo.active"
                        class="dropdown-item dropdown-toggle fw-semibold cursor-pointer">
                        @if (navTwo.icon) {
                          <i
                          class="{{ navTwo.icon }} me-2 ic-inline-style-default"></i>
                        }
                        {{ navTwo.originTitle ? navTwo.originTitle : navTwo.title | transloco }}
                      </a>
                      <div class="dropdown-menu"
                        [class.show]="menuSubStates == 'sub_' + idxTwo">
                        @for (three of navTwo.children; track three) {
                          @if (three.title) {
                            <a class="dropdown-item cursor-pointer fw-semibold"
                              [class.active]="three.active"
                              [routerLink]="three.url"
                              (click)="onHandleClick(three.url)">
                              @if (three.icon) {
                                <i
                                class="{{ three.icon }} me-2 ic-inline-style-default"></i>
                              }
                              {{ three.originTitle ? three.originTitle : three.title | transloco }}
                            </a>
                          }
                        }
                      </div>
                    </div>
                  } @else {
                    @if (navTwo.title) {
                      <a class="dropdown-item rounded cursor-pointer fw-semibold"
                        [class.active]="navTwo.active"
                        [routerLink]="navTwo.url"
                        (click)="onHandleClick(navTwo.url)">
                        @if (navTwo.icon) {
                          <i
                          class="{{ navTwo.icon }} me-2 ic-inline-style-default"></i>
                        }
                        {{ navTwo.originTitle ? navTwo.originTitle : navTwo.title | transloco }}
                      </a>
                    }
                  }
                }
              </div>
            }
          </li>
        }
      </ul>
    </div>
  </div>
</div>
